import React from 'react'
import type { SvgIconProps } from '@material-ui/core/SvgIcon'
import SvgIcon from '@material-ui/core/SvgIcon'

/** Stripe's symbol — a parallelogram inside a circle, in Stripe's brand purple. */
const StripeMark = (props: SvgIconProps) => (
  <SvgIcon viewBox={'0 0 32 32'} {...props}>
    <circle cx="16" cy="16" r="16" fill="#6E67FF" />
    {/* vertical left/right edges, top & bottom sloping up to the right (right side raised) */}
    <path d="M9 12 L23 8 L23 20 L9 24 Z" fill="#fff" />
  </SvgIcon>
)

export default StripeMark
